import { getUser } from 'services/local/auth';
import type { LocalStorageFunctions, LocalCompareDocument } from './types';
import type { ComparableDocument } from 'pages/MyDocuments/types';

const COMPARE_DOCUMENT: string = 'compare-document';

const getLocalStorageCompareDocument = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return undefined;
  const choice = fn.readObject<Record<string, ComparableDocument>>(COMPARE_DOCUMENT);
  if (!choice?.[user.user.email]) return undefined;
  return choice[user.user.email];
};

const setLocalStorageCompareDocument = (fn: LocalStorageFunctions) => (data: ComparableDocument | undefined) => {
  const user = getUser(fn)();
  if (!user) return;
  let choice = fn.readObject<Record<string, ComparableDocument>>(COMPARE_DOCUMENT);
  if (!choice) {
    choice = {};
  }
  if (data) {
    choice[user.user.email] = data;
  } else {
    delete choice[user.user.email];
  }
  fn.writeObject(COMPARE_DOCUMENT, choice);
};

const delLocalStorageCompareDocument = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return;
  const choice = fn.readObject<Record<string, ComparableDocument>>(COMPARE_DOCUMENT);
  if (!choice?.[user.user.email]) return;
  delete choice[user.user.email];
  fn.writeObject(COMPARE_DOCUMENT, choice);
};

const compareDocument = (fn: LocalStorageFunctions): LocalCompareDocument => ({
  getCompareDocument: getLocalStorageCompareDocument(fn),
  setCompareDocument: setLocalStorageCompareDocument(fn),
  delCompareDocument: delLocalStorageCompareDocument(fn)
});

export default compareDocument;
